(function (angular) {
	'use strict';

	angular
		.module('subscriptionPreferencesCenterModule', [
			'coreModule',
			'formValidationModule'
		])
		.value('globalConfig', globalConfig);
		
})(window.angular);